import axios from 'axios';
import { getProject } from '../gcloud/getProject';

const convert = (file, httpRequest = axios, projectUrl = getProject()) => {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${Date.now()}`
  };

  const fd = new FormData()
  fd.append("pdf", file)

  return httpRequest({
    url: `${projectUrl}/convertPdfToPngV2`,
    method: 'POST',
    headers: config,
    data: fd
  })
}

export default { convert }